import { createUseStyles } from "react-jss";
import { colors } from "../../constants/colors";

const styles = createUseStyles(theme => ({
  airlineProgramsPageHeader: {
    padding: 0
  },
  title: {
    color: colors.lightBlack,
    fontWeight: "600",
    fontSize: "30px",
    lineHeight: "38px",
    margin: "0px",
  },
  container: {
    maxWidth: "100%",
    color: colors.mediumGrey,
  },
  dividerContainer: {
    display: "flex",
    alignItems: "center",
  },
  border: {
    width: "100%",
    color: colors.lightGrey,
    opacity: 2,
    margin:"20px 0px 0px 0px"
  }
}));

export default styles;
